import { useTranslation } from "react-i18next";

import { useDashboardCounts } from "../../../features/dashboard/useDashboardCounts";
import { useCompaniesStore } from "../../../store/admin/companiesStore";

export default function CentinelaWatchPill() {
  const { t } = useTranslation("common");
  const companyId = useCompaniesStore((state) => state.companyId);
  const { data } = useDashboardCounts(companyId);

  if (data?.units === undefined) return null;

  return (
    <span className="inline-flex max-w-full items-center gap-2.5 rounded-full border border-primary-500/40 bg-subtle px-4 py-2 max-lg:min-h-10">
      <span className="relative flex h-2 w-2 shrink-0">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
      </span>
      <span className="text-[12.5px] font-medium text-content-secondary">
        {t("monitoreoIa.activePill", {
          name: t("monitoreoIa.assistantName"),
          count: data.units,
        })}
      </span>
    </span>
  );
}
